import React, { Component, useState } from 'react';
import { Alert, Button, Card, CardBody, CardFooter, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import { base_api_url } from '../../../config';
import { toast } from 'react-toastify';
import { Redirect } from 'react-router-dom';
import axios from 'axios';

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [status, setStatus] = useState(0)

  const forgot = (email) => {
    try {
      axios.post(`${base_api_url}Auth/ResetPassword`, {
        email: email,
      })
        .then(function (response) {
          // console.log(response);
          setMessage(response.data.Message)
          setStatus(1);
          redirect()
        })
        .catch(function (error) {
          console.log(error);
          setStatus(2)
        });
    } catch (error) {
    }
  }

  const redirect = () => {
    setTimeout(() => {
      setStatus(10)
    }, 4000)
  }

  return (
    <div className="app flex-row align-items-center">
      <Container>
        <Row className="justify-content-center">
          <Col md="6">
            {status === 1 ? <Alert color="success">
              {message}
            </Alert> : null}
            {status === 2 ? <Alert color="warning">
              Invalid
            </Alert> : null}
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="6">
            <Card className="mx-4">
              <CardBody className="p-4">
                <h1>Forgot Password</h1>
                <p className="text-muted">Reset your password with your email</p>
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>@</InputGroupText>
                  </InputGroupAddon>
                  <Input type="text" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
                </InputGroup>
                <Button color="success" block onClick={() => forgot(email)}>ًSend Link</Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/views/Pages/Register/ForgotPassword.js